import { useMutation, useQueryClient } from "@tanstack/react-query";
import Product from "../interfaces/product";
import useApi from "./useApi";

const useRemoveProduct = () => {
    const { removeById } = useApi<Product>("/products");
    const query = useQueryClient();

    return useMutation({
        mutationFn: (id: number) => removeById(id),
        onSuccess: () => {
            query.invalidateQueries({queryKey: ["products"]});
            }
    })
}

export default useRemoveProduct;